export default __webpack_public_path__ + "static/media/_card-invoice.e518cdcd.svg";